import React from "react";

type Props = {
  status: "low-stock" | "out-of-stock";
};

export const CartProductStockStatus: React.FC<Props> = ({ status }) => {
  const bgClass = status === "low-stock" ? "bg-warning" : "bg-error";

  return (
    <div className="cart__line-item__stock">
      <span className={`cart__line-item__stock-status ${bgClass}`}></span>
      <span className="cart__line-item__stock-label">{status === "low-stock" ? "Low Stock" : "Out Of Stock"}</span>
    </div>
  );
};
